import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  isDrawerOpenAtom,
  isLeftPanelOpenAtom,
  activeMarketFromStorageAtom,
  darkModeAtom,
  exoticModeAtom,
  cexSocketConnectedAtom,
} from '../atoms/globalAtoms';

// Drawer state hook
export function useDrawerState() {
  const [isDrawerOpen, setIsDrawerOpen] = useRecoilState(isDrawerOpenAtom);
  return [isDrawerOpen, setIsDrawerOpen] as const;
}

// Left panel state hook
export function useLeftPanelState() {
  const [isLeftPanelOpen, setIsLeftPanelOpen] = useRecoilState(isLeftPanelOpenAtom);
  return [isLeftPanelOpen, setIsLeftPanelOpen] as const;
}

// Active market from storage hook
export function useActiveMarketFromStorage() {
  const [activeMarketFromStorage, setActiveMarketFromStorage] = useRecoilState(activeMarketFromStorageAtom);
  return [activeMarketFromStorage, setActiveMarketFromStorage] as const;
}

// Read-only hooks
export function useIsDrawerOpen() {
  return useRecoilValue(isDrawerOpenAtom);
}

export function useIsLeftPanelOpen() {
  return useRecoilValue(isLeftPanelOpenAtom);
}

export function useActiveMarketFromStorageValue() {
  return useRecoilValue(activeMarketFromStorageAtom);
}

export function useDarkMode() {
  const [darkMode, setDarkMode] = useRecoilState(darkModeAtom);
  if (darkMode == true) {
    document.body.classList.add('dark');
  } else {
    document.body.classList.remove('dark');
  }
  return [darkMode, setDarkMode] as const;
}

export function useExoticMode() {
  const [exoticMode, setExoticMode] = useRecoilState(exoticModeAtom);
  return [exoticMode, setExoticMode] as const;
}

export function useIsExRoute() {
  return !!window?.location?.href?.includes('/ex/');
}

export function useCexSocketConnected() {
  const [cexSocketConnected, setCexSocketConnected] = useRecoilState(cexSocketConnectedAtom);
  return [cexSocketConnected, setCexSocketConnected] as const;
}